<template>
  <div class="app-breadcrumb" style="margin-bottom: 10px;margin-left: 0px;">
    <m-breadcrumb>
      <m-breadcrumb-item to="/">Home</m-breadcrumb-item>
      <m-breadcrumb-item to="/admin/user">User</m-breadcrumb-item>
      <m-breadcrumb-item>Admin</m-breadcrumb-item>
    </m-breadcrumb>
  </div>
</template>
<script>
import {
  MBreadcrumb,
  MBreadcrumbItem
} from '../core/components/breadcrumb'

export default {
  components: {
    MBreadcrumb,
    MBreadcrumbItem
  }
}
</script>
